<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                    {
                      title: 'Dashboard',
                      url: 'dashboard'
                    },
                    {
                      title: 'Link 1',
                      url: 'link-1'
                    },
                    {
                      title: 'Link 2',
                      url: 'link-1'
                    },
                    {
                      title: 'Active',
                      active: true
                    }
                  ]"
            ></vs-breadcrumb>
            <div class="row dblock" style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);">
              <div class="frm-title">
                <div class="heading mt-3">
                  <h3 class="text-secondary">TRAINEE REGISTRATION</h3>
                </div>
              </div>

              <!-- ======================= -->
              <!-- tabs starts -->
              <div>
                <vs-tabs
                  v-model="tabIndex"
                  alignment="fixed"
                  :color="colorx='rgba(7, 167, 225, 0.61)'"
                >
                  <vs-tab
                    icon="person"
                    @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                    label="Basic Information"
                    style="margin-top:20px;display:block !important;"
                  >
                    <div class="con-tab-ejemplo">
                      <!-- Basic Information starts -->
                      <div class="form-group form-row">
                        <h6 class="sub-frm-title">Basic Information</h6>
                        <!-- floating input starts -->
                        <div class="col-sm-12">
                          <div class="floating-label">
                            <input class="floating-input form-control" type="text" placeholder=" " />

                            <span
                              class="lbl-label"
                              style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                            >
                              <i class="material-icons" style="font-size: 20px;">account_circle</i>
                            </span>
                            <label class="lbl-label">Name (in capital letters)</label>
                          </div>
                        </div>
                        <!-- floating input ends -->
                        <vs-select
                          class="col-sm-6 mt-3"
                          label="Select Identity"
                          v-model="whichSelect"
                        >
                          <vs-select-item
                            :key="index"
                            :value="item.value"
                            :text="item.text"
                            v-for="(item,index) in options1"
                          />
                        </vs-select>

                        <div class="col-sm-6 mt-45" v-if="whichSelect === 0">
                          <div class="floating-label">
                            <input class="floating-input form-control" type="text" placeholder=" " />
                            <span
                              class="lbl-label"
                              style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                            >
                              <i class="material-icons" style="font-size: 20px;">credit_card</i>
                            </span>
                            <label class="lbl-label">Passport</label>
                          </div>
                        </div>
                        <div class="col-sm-6 mt-45" v-if="whichSelect === 1">
                          <div class="floating-label">
                            <input class="floating-input form-control" type="text" placeholder=" " />

                            <span
                              class="lbl-label"
                              style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                            >
                              <i class="material-icons" style="font-size: 20px;">credit_card</i>
                            </span>
                            <label class="lbl-label">CNIC Number</label>
                          </div>
                        </div>

                        <!-- Gender starts -->
                        <div class="col-sm-4 mt-3" style="padding-left: 5px;display: inline-flex;">
                          <label class="col-sm-4 col-form-label">Gender</label>
                          <div class="col-sm-4" style="margin-top:7px">
                            <vs-radio v-model="radios1" vs-name="radios1" vs-value="male">Male</vs-radio>
                          </div>
                          <div class="col-sm-4" style="margin-top:7px">
                            <vs-radio v-model="radios1" vs-name="radios1" vs-value="female">Female</vs-radio>
                          </div>
                          <div class="col-sm-6" style="margin-top:7px">
                            <vs-radio
                              v-model="gender"
                              vs-name="radios1"
                              vs-value="rather not say"
                            >Rather not say</vs-radio>
                          </div>
                        </div>
                        <!-- Gender ends -->
                        <!-- Address starts -->
                        <div class="row" style="width:100%">
                          <div class="col-sm-6 mt-3">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                type="text"
                                placeholder=" "
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i class="material-icons" style="font-size: 20px;">local_phone</i>
                              </span>
                              <label class="lbl-label">Mobile Number</label>
                            </div>
                          </div>
                          <div class="col-sm-6 mt-3">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                type="text"
                                placeholder=" "
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i class="material-icons" style="font-size: 20px;">email</i>
                              </span>
                              <label class="lbl-label">Email</label>
                            </div>
                          </div>
                          <vs-select
                            class="col-sm-4 mt-3"
                            style="width:100%;"
                            label="Country"
                            v-model="select7"
                          >
                            <vs-select-item
                              :key="index"
                              :value="item.value"
                              :text="item.text"
                              v-for="(item,index) in countryArr"
                            />
                          </vs-select>
                          <vs-select
                            class="col-sm-4 mt-3"
                            style="width:100%;"
                            label="Province"
                            v-model="select8"
                          >
                            <vs-select-item
                              :key="index"
                              :value="item.value"
                              :text="item.text"
                              v-for="(item,index) in provinceArr"
                            />
                          </vs-select>
                          <vs-select
                            class="col-sm-4 mt-3"
                            style="width:100%;"
                            label="District"
                            v-model="select9"
                          >
                            <vs-select-item
                              :key="index"
                              :value="item.value"
                              :text="item.text"
                              v-for="(item,index) in districtArr"
                            />
                          </vs-select>
                          <!-- floating input starts -->
                          <div class="col-sm-12 mt-3">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                type="text"
                                placeholder=" "
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i class="material-icons" style="font-size: 20px;">place</i>
                              </span>
                              <label class="lbl-label">Address</label>
                            </div>
                          </div>
                          <!-- floating input ends -->
                        </div>
                        <!-- Address ends -->
                      </div>
                      <!-- Basic Information ends -->
                    </div>
                    <!-- next button starts-->
                    <b-button @click="tabIndex++" class="save-btn" variant="primary">Next</b-button>
                    <!-- next button ends -->
                  </vs-tab>
                  <vs-tab
                    icon="business_center"
                    @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                    label="Employment Information"
                  >
                    <div class="con-tab-ejemplo">
                      <!--Employment Information starts -->
                      <div class="form-group form-row">
                        <h6 class="sub-frm-title">Employment Information</h6>
                        <!-- Accademic Qualification starts -->
                        <div class="col-sm-12">
                          <!-- <h6 style="color:#212529;font-size:15px;">Accademic Qualification</h6> -->
                          <div class="table-responsive-sm">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th scope="col">Department Name</th>
                                  <!-- <th scope="col">Degree Name</th>
                                  <th scope="col">Degree Subject</th>-->
                                  <th scope="col">Designation / Rank</th>
                                  <!-- <th scope="col"></th> -->
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <div>
                                      <input
                                        style="line-height: 3; height: 36px; box-shadow: none !important"
                                        type="text"
                                        class="form-control"
                                        id="inputtext"
                                        placeholder
                                      />
                                    </div>
                                  </td>

                                  <td>
                                    <div>
                                      <input
                                        style="line-height: 3; height: 36px; box-shadow: none !important"
                                        type="text"
                                        class="form-control"
                                        id="inputtext"
                                        placeholder
                                      />
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <!-- Accademic Qualification ends -->
                      </div>
                      <!--Employment Information ends -->
                    </div>
                    <!-- next button starts-->
                    <b-button @click="tabIndex++" class="save-btn" variant="primary">Next</b-button>
                    <!-- next button ends -->
                    <!-- next button starts-->
                    <b-button @click="tabIndex--" class="previous-btn" variant="primary">Previous</b-button>
                    <!-- next button ends -->
                  </vs-tab>
                  <vs-tab
                    icon="school"
                    @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                    label="Academic Qualification"
                  >
                    <div class="con-tab-ejemplo">
                      <!--Academic Qualification (Last Attended Degree) starts -->
                      <div class="form-group form-row">
                        <h6 class="sub-frm-title">Academic Qualification (Last Attended Degree)</h6>
                        <!-- Employment Record starts -->
                        <div class="col-sm-12">
                          <div class="table-responsive-sm">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th scope="col">Degree / Certificate</th>
                                  <th scope="col">Passing Year</th>
                                  <th scope="col">University / Institute</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <div>
                                      <input
                                        style="line-height: 3; height: 36px; box-shadow: none !important"
                                        type="text"
                                        class="form-control"
                                        id="inputtext"
                                        placeholder
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <input
                                        style="line-height: 3; height: 36px; box-shadow: none !important"
                                        type="text"
                                        class="form-control"
                                        id="inputtext"
                                        placeholder
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <input
                                        style="line-height: 3; height: 36px; box-shadow: none !important"
                                        type="text"
                                        class="form-control"
                                        id="inputtext"
                                        placeholder
                                      />
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <!-- Employment Record ends -->
                      </div>
                      <!--Academic Qualification (Last Attended Degree) ends -->
                    </div>
                    <!-- next button starts-->
                    <b-button @click="tabIndex++" class="save-btn" variant="primary">Next</b-button>
                    <!-- next button ends -->
                    <!-- next button starts-->
                    <b-button @click="tabIndex--" class="previous-btn" variant="primary">Previous</b-button>
                    <!-- next button ends -->
                  </vs-tab>
                  <vs-tab
                    icon="dvr"
                    @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                    label="Apply for Training"
                  >
                    <div class="con-tab-ejemplo">
                      <!--Apply for Training starts -->
                      <div class="form-group form-row">
                        <h6 class="sub-frm-title">Apply for Training</h6>
                        <!-- Conducted Trainings for UNODC starts -->
                        <div class="col-sm-12">
                          <!-- <h6 style="color:#212529;font-size:15px;">Conducted Trainings for UNODC</h6> -->
                          <div class="table-responsive-sm">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th scope="col">Training Name</th>
                                  <th scope="col">Training Code</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <div>
                                      <vs-select style="width: 100% !important;" v-model="select7">
                                        <vs-select-item
                                          :key="index"
                                          :value="item.value"
                                          :text="item.text"
                                          v-for="(item,index) in trainingArr"
                                        />
                                      </vs-select>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <input
                                        style="line-height: 3; height: 36px; box-shadow: none !important; height: calc(1.3em + 0.75rem + 2px)"
                                        type="text"
                                        class="form-control"
                                        id="inputtext"
                                        placeholder=""
                                      />
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <!-- Conducted Trainings for UNODC ends -->
                        <!-- ============================== -->
                      </div>
                      <!--Apply for Training ends -->
                    </div>

                    <!-- next button starts-->
                    <!-- <b-button @click="tabIndex++" class="save-btn" variant="primary">Next</b-button> -->
                    <b-button class="save-btn" variant="primary">Save</b-button>
                    <!-- next button ends -->
                    <!-- next button starts-->
                    <b-button @click="tabIndex--" class="previous-btn" variant="primary">Previous</b-button>

                    <!-- next button ends -->
                  </vs-tab>
                </vs-tabs>
              </div>
              <!-- tabs ends -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import VueTagsInput from "@johmun/vue-tags-input";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  data: () => ({
    isSidebar: false,
    whichSelect: 0,
    options1: [{ text: "Passport", value: 0 }, { text: "CNIC", value: 1 }],
    radios1: "",
    isForm: true,
    isFormData: false,
    selected: "",
    tabIndex: 0,
    contact_person: "",
    contact_number: "",
    contact_email: "",
    address: "",
    options: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    components: {
      VueTagsInput
    },
    tag: "",
    tags: [],

    checkBox1: false,
    checkBox2: false,
    checkBox3: false,
    checkBox4: false,
    textarea: "",
    counterDanger: false,
    mydate: "",
    startDate: "",
    endDate: "",
    colorx: "#1db952",
    trainingCheck: false,
    repeatedCheck: false,
    select1Normal: "",
    select1: 0,
    select2: 1,
    select3: 0,
    select4: 1,
    select5: 1,
    select6: 1,
    select7: 1,
    select8: 1,
    select9: 1,
    select10: 0,
    select11: 1,
    select12: 1,
    select13: 1,
    select14: 1,
    thematicareaSelected: "",
    thematicareasettings: {
      valueField: "code",
      labelField: "name",
      maxItems: 5,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    traineridentityArr: [
      { text: "CNIC Number", value: 1 },
      {
        text: "Passport Number",
        value: 2
      }
    ],
    languageskillsArr: [
      { text: "English", value: 1 },
      { text: "French", value: 2 },
      { text: "German", value: 3 },
      { text: "Chinese", value: 4 }
    ],
    selectlevelArr: [
      { text: "Good", value: 1 },
      { text: "Very Good", value: 2 },
      { text: "Excellent", value: 3 },
      { text: "Weak", value: 4 }
    ],
    countryArr: [
      { text: "Pakistan", value: 1 },
      {
        text: "Afghanistan",
        value: 2
      },
      {
        text: "India",
        value: 3
      },
      {
        text: "Bangladesh",
        value: 4
      },
      {
        text: "Other",
        value: 5
      }
    ],
    trainingArr: [
      { text: "Java", value: 1 },
      { text: "Wordpress", value: 2 },
      { text: "Web Development", value: 3 },
      { text: "Graphic Designing", value: 4 },
      { text: "Digital Marketing", value: 5 }
    ],
    provinceArr: [
      { text: "Khyber Pakhtunkhwa", value: 1 },
      {
        text: "PUNJAB",
        value: 2
      },
      {
        text: "Islamabad",
        value: 3
      },
      {
        text: "Sind",
        value: 4
      },
      {
        text: "Balochistan",
        value: 5
      },
      {
        text: "Azad Kashmir",
        value: 6
      }
    ],
    districtArr: [
      { text: "Mardan", value: 1 },
      {
        text: "Peshawar",
        value: 2
      }
    ],
    items: [],
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
  },

  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    successUpload() {
      this.$vs.notify({
        color: "primary",
        title: "Upload Success",
        text: "Your file is uploaded Successfully."
      });
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    }
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}

.mt-45 {
  margin-top: 45px;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #ffffff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #fff;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
/****  floating-Lable style end ****/
/* Floating label css ends */

.add-btn {
  font-size: 25px;
  color: rgba(7, 167, 225, 0.61);
  cursor: pointer;
}
.previous-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: left;
  margin: 10px 0px;
}
</style>
